import { gcApi } from 'config/axios';
import { call, put, fork, takeLatest } from 'redux-saga/effects';

import {
    // leaderboard
    FETCH_CONNECTIONS_LEADERBOARD,
    FETCH_CONNECTIONS_LEADERBOARD_START,
    FETCH_CONNECTIONS_LEADERBOARD_SUCCESS,
    FETCH_CONNECTIONS_LEADERBOARD_FAIL
} from 'actions/ActionTypes';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';

export function* fetchConnectionsLeaderboard(action) {
    try {
        yield put({
            type: FETCH_CONNECTIONS_LEADERBOARD_START
        });

        const { metricId, startDate, endDate, userType, start, limit, actTypeId } = action.payload;

        let url = `/userstats-service/leaderboard/${userType}/connection?metricId=${metricId}&startDate=${startDate}&endDate=${endDate}&start=${start}&limit=${limit}`;
        if (actTypeId) {
            url = url + '&actTypeId=' + actTypeId;
        }

        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_CONNECTIONS_LEADERBOARD_SUCCESS,
            data: response.data
        });

        yield fork(fetchLeaderboardProfileImageAndFrame, response.data);
    } catch (e) {
        yield put({
            type: FETCH_CONNECTIONS_LEADERBOARD_FAIL
        });
    }
}

/**
 *
 * @param {Object} responseData
 * @param {Object} responseData.allMetrics
 * @param {Object} responseData.allMetrics.metricsMap
 * @returns
 */
function* fetchLeaderboardProfileImageAndFrame(responseData) {
    if (!responseData?.allMetrics?.metricsMap) {
        return;
    }
    /**
     * @type {{ userInfo: { userProfilePk: number } }[]}
     */
    const leaderboardList =
        responseData.allMetrics.metricsMap.WELLNESS_TOTAL_PUSHES ||
        responseData.allMetrics.metricsMap.WELLNESS_TOTAL_STEPS ||
        responseData.allMetrics.metricsMap.ACTIVITY_TOTAL_DISTANCE;

    if (!leaderboardList || !leaderboardList.length) {
        return;
    }
    const userIds = leaderboardList.map((item) => item.userInfo.userProfilePk);

    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

/** fetch profile image and frame */
export function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

export const leaderboardSagas = [takeLatest(FETCH_CONNECTIONS_LEADERBOARD, fetchConnectionsLeaderboard)];
